import { render, staticRenderFns } from "./indexTab1.vue?vue&type=template&id=3ab8aa7b&scoped=true"
import script from "./indexTab1.vue?vue&type=script&lang=js"
export * from "./indexTab1.vue?vue&type=script&lang=js"
import style0 from "./indexTab1.vue?vue&type=style&index=0&id=3ab8aa7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab8aa7b",
  null
  
)

export default component.exports